import type { TFunction } from 'i18next';
import { cn } from '@easymoving/ui';
import type { Destination, ProgressStatus } from '@easymoving/types';
import { destinationOptions, statusOptions } from '../../lib/taxonomy/options';
import { destinationTone, statusTone, toneDot } from '../../lib/taxonomy/tone';

/** Compact trigger sizing for inline quick-edit selects (overrides Select defaults). */
export const COMPACT_SELECT = 'w-auto max-w-full px-2.5 py-1.5 text-[13px] gap-1.5';

function dotLabel(text: string, toneClass: string) {
  return (
    <span className="inline-flex items-center gap-2 min-w-0">
      <span className={cn('size-2 rounded-full shrink-0', toneClass)} />
      <span className="truncate">{text}</span>
    </span>
  );
}

export function destinationDotOptions(t: TFunction): { value: Destination; label: React.ReactNode }[] {
  return (destinationOptions(t) as { value: Destination; label: string }[]).map((o) => ({
    value: o.value,
    label: dotLabel(o.label, toneDot[destinationTone(o.value)]),
  }));
}

export function statusDotOptions(t: TFunction): { value: ProgressStatus; label: React.ReactNode }[] {
  return (statusOptions(t) as { value: ProgressStatus; label: string }[]).map((o) => ({
    value: o.value,
    label: dotLabel(o.label, toneDot[statusTone(o.value)]),
  }));
}
